import styled, { keyframes } from 'styled-components';

const visibility = keyframes`
    from {
      opacity: 0;
    }
    66% {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const StyledWrapper = styled.div`
    &&.elmo-calendar {
        .rc-calendar {
            //&-active-week {
            //    background-color: var(--information-50);
            //}
            //
            //&-selected-date {
            //    color: initial;
            //}

            .rc-calendar-cell.rc-calendar-last-month-cell,
            .rc-calendar-cell.rc-calendar-next-month-btn-day {
                display: table-cell;
                visibility: visible;
                opacity: 1;
                animation: ${visibility} 0.4s linear;
            }
        }
    }
`;
